
    <template>
      <section class="relax-doc">
        <h1>Tooltip 文字提示</h1>
<blockquote>
<p>用于辅助的文字提示，可代替 HTML 元素默认的 title 属性</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>基本使用</p>
</blockquote>
<demo-block>
        <p>文字必须要被标签包裹</p>

        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-tooltip content=&quot;这是文字提示&quot;&gt;
    &lt;span&gt;文字提示&lt;/span&gt;
  &lt;/x-tooltip&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="wei-zhi"><a class="header-anchor" href="#wei-zhi"></a> 位置</h2>
<blockquote>
<p>left , top , right , bottom 是物理中的 4 个方向, 表示显示的位置</p>
</blockquote>
<demo-block>
        <p>通过<code>placement</code>设置不同的位置</p>

        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;div class=&quot;tooltip-box&quot;&gt;
    &lt;x-row type=&quot;flex&quot; justify=&quot;center&quot;&gt;
      &lt;x-col :span=&quot;5&quot;&gt;
        &lt;x-tooltip content=&quot;这是文字提示&quot; placement=&quot;top-start&quot;&gt;
          &lt;x-button type=&quot;primary&quot; plain&gt; 上左 &lt;/x-button&gt;
        &lt;/x-tooltip&gt;
      &lt;/x-col&gt;
      &lt;x-col :span=&quot;5&quot;&gt;
        &lt;x-tooltip content=&quot;这是文字提示&quot; placement=&quot;top&quot;&gt;
          &lt;x-button type=&quot;primary&quot; plain&gt; 上中 &lt;/x-button&gt;
        &lt;/x-tooltip&gt;
      &lt;/x-col&gt;
      &lt;x-col :span=&quot;5&quot;&gt;
        &lt;x-tooltip content=&quot;这是文字提示&quot; placement=&quot;top-end&quot;&gt;
          &lt;x-button type=&quot;primary&quot; plain&gt; 上右 &lt;/x-button&gt;
        &lt;/x-tooltip&gt;
      &lt;/x-col&gt;
    &lt;/x-row&gt;

    &lt;x-row type=&quot;flex&quot; justify=&quot;space-between&quot;&gt;
      &lt;x-col :span=&quot;4&quot;&gt;
        &lt;x-tooltip content=&quot;这是文字提示&quot; placement=&quot;left-start&quot;&gt;
          &lt;x-button type=&quot;primary&quot; plain&gt; 左上 &lt;/x-button&gt;
        &lt;/x-tooltip&gt;
      &lt;/x-col&gt;
      &lt;x-col :span=&quot;4&quot;&gt;
        &lt;x-tooltip content=&quot;这是文字提示&quot; placement=&quot;right-start&quot;&gt;
          &lt;x-button type=&quot;primary&quot; plain&gt; 右上 &lt;/x-button&gt;
        &lt;/x-tooltip&gt;
      &lt;/x-col&gt;
    &lt;/x-row&gt;

    &lt;x-row type=&quot;flex&quot; justify=&quot;space-between&quot;&gt;
      &lt;x-col :span=&quot;4&quot;&gt;
        &lt;x-tooltip content=&quot;这是文字提示&quot; placement=&quot;left&quot;&gt;
          &lt;x-button type=&quot;primary&quot; plain&gt; 左中 &lt;/x-button&gt;
        &lt;/x-tooltip&gt;
      &lt;/x-col&gt;
      &lt;x-col :span=&quot;4&quot;&gt;
        &lt;x-tooltip content=&quot;这是文字提示&quot; placement=&quot;right&quot;&gt;
          &lt;x-button type=&quot;primary&quot; plain&gt; 右中 &lt;/x-button&gt;
        &lt;/x-tooltip&gt;
      &lt;/x-col&gt;
    &lt;/x-row&gt;

    &lt;x-row type=&quot;flex&quot; justify=&quot;space-between&quot;&gt;
      &lt;x-col :span=&quot;4&quot;&gt;
        &lt;x-tooltip content=&quot;这是文字提示&quot; placement=&quot;left-end&quot;&gt;
          &lt;x-button type=&quot;primary&quot; plain&gt; 左下 &lt;/x-button&gt;
        &lt;/x-tooltip&gt;
      &lt;/x-col&gt;
      &lt;x-col :span=&quot;4&quot;&gt;
        &lt;x-tooltip content=&quot;这是文字提示&quot; placement=&quot;right-end&quot;&gt;
          &lt;x-button type=&quot;primary&quot; plain&gt; 右下 &lt;/x-button&gt;
        &lt;/x-tooltip&gt;
      &lt;/x-col&gt;
    &lt;/x-row&gt;

    &lt;x-row type=&quot;flex&quot; justify=&quot;center&quot;&gt;
      &lt;x-col :span=&quot;5&quot;&gt;
        &lt;x-tooltip content=&quot;这是文字提示&quot; placement=&quot;bottom-start&quot;&gt;
          &lt;x-button type=&quot;primary&quot; plain&gt; 下左 &lt;/x-button&gt;
        &lt;/x-tooltip&gt;
      &lt;/x-col&gt;
      &lt;x-col :span=&quot;5&quot;&gt;
        &lt;x-tooltip content=&quot;这是文字提示&quot; placement=&quot;bottom&quot;&gt;
          &lt;x-button type=&quot;primary&quot; plain&gt; 下中 &lt;/x-button&gt;
        &lt;/x-tooltip&gt;
      &lt;/x-col&gt;
      &lt;x-col :span=&quot;5&quot;&gt;
        &lt;x-tooltip content=&quot;这是文字提示&quot; placement=&quot;bottom-end&quot;&gt;
          &lt;x-button type=&quot;primary&quot; plain&gt; 下右 &lt;/x-button&gt;
        &lt;/x-tooltip&gt;
      &lt;/x-col&gt;
    &lt;/x-row&gt;

  &lt;/div&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="she-zhi-kuan-du"><a class="header-anchor" href="#she-zhi-kuan-du"></a> 设置宽度</h2>
<blockquote>
<p>可以设置<code>tooltip</code>的宽度 换行可以用 <code>br</code></p>
</blockquote>
<demo-block>
        <p>文字必须要被标签包裹</p>

        <template #source><element-demo2 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-tooltip content=&quot;这是一段非常长的文字提示，主要是用于演示&quot; width=&quot;180px&quot;&gt;
    &lt;span&gt;文字提示&lt;/span&gt;
  &lt;/x-tooltip&gt;
&lt;/template&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { createElementVNode: _createElementVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_tooltip = _resolveComponent("x-tooltip")

  return (_openBlock(), _createBlock(_component_x_tooltip, { content: "这是文字提示" }, {
    default: _withCtx(() => [
      _createElementVNode("span", null, "文字提示")
    ]),
    _: 1
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")
  const _component_x_tooltip = _resolveComponent("x-tooltip")
  const _component_x_col = _resolveComponent("x-col")
  const _component_x_row = _resolveComponent("x-row")

  return (_openBlock(), _createElementBlock("div", { class: "tooltip-box" }, [
    _createVNode(_component_x_row, {
      type: "flex",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, { span: 5 }, {
          default: _withCtx(() => [
            _createVNode(_component_x_tooltip, {
              content: "这是文字提示",
              placement: "top-start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_x_button, {
                  type: "primary",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 上左 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 5 }, {
          default: _withCtx(() => [
            _createVNode(_component_x_tooltip, {
              content: "这是文字提示",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_x_button, {
                  type: "primary",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 上中 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 5 }, {
          default: _withCtx(() => [
            _createVNode(_component_x_tooltip, {
              content: "这是文字提示",
              placement: "top-end"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_x_button, {
                  type: "primary",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 上右 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_x_row, {
      type: "flex",
      justify: "space-between"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_x_tooltip, {
              content: "这是文字提示",
              placement: "left-start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_x_button, {
                  type: "primary",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 左上 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_x_tooltip, {
              content: "这是文字提示",
              placement: "right-start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_x_button, {
                  type: "primary",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 右上 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_x_row, {
      type: "flex",
      justify: "space-between"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_x_tooltip, {
              content: "这是文字提示",
              placement: "left"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_x_button, {
                  type: "primary",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 左中 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_x_tooltip, {
              content: "这是文字提示",
              placement: "right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_x_button, {
                  type: "primary",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 右中 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_x_row, {
      type: "flex",
      justify: "space-between"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_x_tooltip, {
              content: "这是文字提示",
              placement: "left-end"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_x_button, {
                  type: "primary",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 左下 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_x_tooltip, {
              content: "这是文字提示",
              placement: "right-end"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_x_button, {
                  type: "primary",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 右下 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_x_row, {
      type: "flex",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_x_col, { span: 5 }, {
          default: _withCtx(() => [
            _createVNode(_component_x_tooltip, {
              content: "这是文字提示",
              placement: "bottom-start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_x_button, {
                  type: "primary",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 下左 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 5 }, {
          default: _withCtx(() => [
            _createVNode(_component_x_tooltip, {
              content: "这是文字提示",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_x_button, {
                  type: "primary",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 下中 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_x_col, { span: 5 }, {
          default: _withCtx(() => [
            _createVNode(_component_x_tooltip, {
              content: "这是文字提示",
              placement: "bottom-end"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_x_button, {
                  type: "primary",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 下右 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    const { createElementVNode: _createElementVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_tooltip = _resolveComponent("x-tooltip")

  return (_openBlock(), _createBlock(_component_x_tooltip, {
    content: "这是一段非常长的文字提示，主要是用于演示",
    width: "180px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", null, "文字提示")
    ]),
    _: 1
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  